import { logWrapper } from '../../utils';

export default {
  signCertificataService: [
    'runtimeConstant',
    '$http',
    '$q',
    'webApiSettings',
    '$filter',
    function (runtimeConstant, $http, $q, webApiSettings, $filter) {
      'use strict';

      function handleErrorCredentials(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }
        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR INSERT CREDENTIALS'),
        };
      }

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }
        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')(err.toUpperCase()),
        };
      }

      function sendCertificataCredendials(credentials) {
        var deferred = $q.defer();
        var url = 'certificata/user/credentials';
        $http
          .post(webApiSettings.apiServiceBaseUri + url, credentials, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleErrorCredentials(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function postEnvelope(envelope) {
        var deferred = $q.defer();
        var url = 'certificata/create/envelope';

        $http
          .post(webApiSettings.apiServiceBaseUri + url, envelope, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function getLinkSignersCertificata(idSignatureCertificata) {
        var deferred = $q.defer();
        var url = 'certificata/link/signer' + '/' + idSignatureCertificata;

        $http
          .get(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function getSignersCertificata(idRevision, revisionNumber) {
        var deferred = $q.defer();
        var url =
          'certificata/signers' + '/' + idRevision + '/' + revisionNumber;

        $http
          .get(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });
        return deferred.promise;
      }

      function getSuggestionsSignersCertificata(term, typeChannel) {
        var deferred = $q.defer();
        var url =
          'certificata/signers/suggestions/' +
          encodeURIComponent(term) +
          '/' +
          encodeURIComponent(typeChannel);

        $http
          .get(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function getPendingSignsCertificata(email, phone) {
        var deferred = $q.defer();
        var url = 'certificata/pendingSigns';

        var params = [];

        if (email) {
          params.push('email=' + encodeURIComponent(email));
        }

        if (phone) {
          params.push('phone=' + encodeURIComponent(phone));
        }

        if (params.length > 0) {
          url += '?' + params.join('&');
        }

        $http
          .get(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function getSignatoriesCertificata() {
        var deferred = $q.defer();
        var url = 'certificata/signatories';

        $http
          .get(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function run() {
        try {
          var signCertificataFactory = {};

          signCertificataFactory.sendCertificataCredendials = logWrapper(
            sendCertificataCredendials,
            runtimeConstant.isDebugServicesInternals
          );
          signCertificataFactory.postEnvelope = logWrapper(
            postEnvelope,
            runtimeConstant.isDebugServicesInternals
          );
          signCertificataFactory.getSignersCertificata = logWrapper(
            getSignersCertificata,
            runtimeConstant.isDebugServicesInternals
          );
          signCertificataFactory.getLinkSignersCertificata = logWrapper(
            getLinkSignersCertificata,
            runtimeConstant.isDebugServicesInternals
          );
          signCertificataFactory.getSuggestionsSignersCertificata = logWrapper(
            getSuggestionsSignersCertificata,
            runtimeConstant.isDebugServicesInternals
          );
          signCertificataFactory.getPendingSignsCertificata = logWrapper(
            getPendingSignsCertificata,
            runtimeConstant.isDebugServicesInternals
          );
          signCertificataFactory.getSignatoriesCertificata = logWrapper(
            getSignatoriesCertificata,
            runtimeConstant.isDebugServicesInternals
          );

          return signCertificataFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};